import React from 'react';
import { PartnersTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import { Partner } from '@v2/types';

const columns: Column<Partner>[] = [
  {
    key: 'name',
    header: 'Name',
    sortKey: 'name',
    render: (row) => (
      <div className={styles.nameContainer}>
        <div className={styles.avatar}>
          {row.name?.charAt(0)?.toUpperCase()}
        </div>
        <span className={styles.name}>
          {row.name}
        </span>
      </div>
    ),
  }
];

const PartnersTable: React.FC<PartnersTableProps> = ({
  partners,
  loading,
  error,
  onSelectPartner,
  selectedPartnerId,
  sortConfig,
  onSortChange,
  search,
  onSearchChange,
  searchPlaceholder,
}) => (
  <Table<Partner>
    columns={columns}
    data={partners}
    keyExtractor={(partner) => partner.id}
    loading={loading}
    error={error}
    emptyMessage="No partners found."
    onRowClick={onSelectPartner}
    selectedKeys={selectedPartnerId ? [selectedPartnerId] : []}
    sortConfig={sortConfig ?? null}
    onSortChange={onSortChange}
    search={search}
    onSearchChange={onSearchChange}
    searchPlaceholder={searchPlaceholder}
  />
);

export default PartnersTable;
